<template>
  <div class="custom">
    <div class="fx" v-if="showSettlementMethod && settlementMethodList && settlementMethodList.length > 0">
      <div class="title">结算方式</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.settlementMethod" size="small" @change="getSizeRange($event, 'settlementMethod')">
          <span class="inchesFix">
            <el-radio-button v-for="item in settlementMethodList" :key="item.value" :value="item.value" :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="genderList && genderList.length > 0">
      <div class="title">款式</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.gender" size="small" @change="getSizeRange($event, 'gender')">
          <span class="inchesFix">
            <el-radio-button v-for="item in genderList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="formatTypes && formatTypes.length > 0">
      <div class="title">版型</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.formatType" size="small" @change="getSizeRange($event, 'formatType')">
          <span class="inchesFix">
            <el-radio-button v-for="item in formatTypes" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="lcTechnologList && lcTechnologList.length > 0">
      <div class="title">鎏彩工艺</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.lcTechnology" size="small" @change="getSizeRange($event, 'lcTechnology')">
          <span class="inchesFix">
            <el-radio-button v-for="item in lcTechnologList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="goldenWeighList && goldenWeighList.length > 0">
      <div class="title">金重</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh')">
          <span class="inchesFix">
            <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="handSizeList && handSizeList.length > 0">
      <div class="title">
        规格
        <span class="inchesTips" v-if="handSizeList && handSizeList[0].includes('寸')">(1英寸=2.54厘米)</span>
      </div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.ringSize" size="small" @change="getSizeRange($event, 'ringSize')">
          <span class="inchesFix">
            <el-radio-button v-for="item in handSizeList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="textareaRemark">
      <div class="title">备注</div>
      <el-input
        v-model="dataFrom.productRemark"
        :rows="6"
        :maxlength="64"
        type="textarea"
        placeholder="其他要求与说明请在此处备注说明，字符数限制64位"
      ></el-input>
    </div>
    <div class="box_detail_input price-wrap">
      <div
        class="price-tips"
        v-if="
          (tradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))) ||
          (labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)) ||
          (dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0)
        "
      >
        (预估价格，实际价格请以结算为准)
      </div>
      <div>
        <div class="box_detail_input marginFx" v-if="settlementWeight && dataFrom.settlementMethod == 2">
          <div class="input-wrap">结算金重：{{ settlementWeight }}</div>
        </div>
        <div
          class="box_detail_input marginFx"
          v-if="tradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))"
        >
          <div class="input-wrap">{{ dataFrom.settlementMethod == 2 ? '结算工费' : '结算金额' }}：{{ tradePrice }}</div>
        </div>
        <div class="box_detail_input marginFx" v-if="labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)">
          <div class="input-wrap">标签价格：{{ labelPrice }}</div>
        </div>
        <div class="box_detail_input marginFx" v-if="dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0 && dataFrom.settlementMethod != 2">
          <div class="input-wrap">尊享价：{{ dataFrom.exclusivePrice }}</div>
        </div>
      </div>
    </div>
    <div class="box_detail_input marginFx">
      <div class="input-wrap">
        <span class="prompt groupColor" v-if="groupFlag != 1">起订量{{ leastQuantity }}件，可定单不同规格</span>
        <span class="prompt groupColor" v-if="groupFlag == 1">注：拼团有效期为10天，逾期则拼团失败（还差{{ dataFrom.quantityToGroup }}件成团）</span>
        <span class="prompt placeNum">购买数量：</span>
        <el-input-number
          v-model="dataFrom.quantity"
          :min="groupFlag == 1 ? 1 : leastQuantity"
          :max="9999"
          label="描述文字"
          @change="getSizeRange($event, 'quantity')"
        ></el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
import { PRODUCT_CATEGOYR_NAME } from '@/utils/const';
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { deepClone } from '@/utils/util';
import { Decimal } from 'decimal.js';

export default {
  name: 'Custom',
  props: {
    DataList: {
      type: Object,
      default() {
        return {};
      },
    },
    settlementMethodList: {
      type: Array,
      default() {
        return [];
      },
    },
    leastQuantity: {
      type: Number,
      default: 0,
    },
    groupFlag: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      dataFrom: {
        styleNumber: this.DataList.styleNumber,
        productName: this.DataList.productName,
        isCouples: this.DataList.isCouples,
        classify: 1,
        quantity: 0,
        shopType: 2,
        spotFlag: 2,
        ringSize: '',
        goldWeigh: '',
        lcTechnology: '',
        formatType: '',
        productRemark: '',
        gender: '女',
        tradePrice: '',
        labelPrice: '',
        exclusivePrice: '',
        settlementMethod: '',
      },
      dropDownOptional: {},
      goldenWeighList: [],
      handSizeList: [],
      lcTechnologList: [],
      formatTypes: [],
      genderList: ['女', '男'],
      productCategoryList: PRODUCT_CATEGOYR_NAME,
      lcTechnologyIndex: 0,
      formatTypeIndex: 0,
      tradePrice: '',
      labelPrice: '',
      settlementWeight: 0,
    };
  },
  computed: {
    showSettlementMethod() {
      const displayFlag = this.dropDownOptional.factorySource != 1;
      return displayFlag;
    },
  },
  mounted() {
    this.dataFrom = { ...this.dataFrom, ...this.DataList };
    this.getOptional();
  },
  methods: {
    defaultSelected() {
      // if (this.formatTypes.length == 1) {
      //   this.dataFrom.formatType = this.formatTypes[0];
      // }
      // if (this.dropDownOptional.lcTechnologyFlag == 1) {
      //   if (this.lcTechnologList.length == 1) {
      //     this.dataFrom.lcTechnology = this.lcTechnologList[0];
      //   }
      //   if (this.goldenWeighList.length == 1) {
      //     this.dataFrom.goldWeigh = this.goldenWeighList[0];
      //   }
      //   if (this.handSizeList.length == 1) {
      //     this.dataFrom.ringSize = this.handSizeList[0];
      //   }
      // } else {
      //   if (this.goldenWeighList.length == 1) {
      //     this.dataFrom.goldWeigh = this.goldenWeighList[0];
      //   }
      //   if (this.handSizeList.length == 1) {
      //     this.dataFrom.ringSize = this.handSizeList[0];
      //   }
      // }
    },
    mainStoneSort(list) {
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range };
      });
      parsedRanges.sort((a, b) => a.start - b.start);
      return parsedRanges.map((item) => item.range);
    },
    getOptional() {
      const obj = {
        styleNumber: this.DataList.styleNumber,
        classify: 1,
        spotFlag: 2,
        gender: '',
        otherType: this.$route.query.codeType == 'gold18_style' ? 2 : null,
      };
      getOptional(obj).then((res) => {
        this.dropDownOptional = { ...this.dropDownOptional, ...res.data };
        // 平台默认结价
        if (this.dropDownOptional.factorySource && this.dropDownOptional.factorySource == '1') {
          this.dataFrom.settlementMethod = 1;
        } else {
          this.dataFrom.settlementMethod = 2;
        }
        this.assembleOptionalData();
        this.defaultSelected();
        this.fetchPriceRange();
      });
    },
    pickCurrentValue(list, value) {
      return list.includes(value) ? value : list[0] || '';
    },
    assembleOptionalData() {
      const couplesMap = this.dropDownOptional.couplesMap?.[this.dataFrom.gender] || {};
      this.formatTypes = this.dropDownOptional.formatTypeFlag == 1 ? Object.keys(couplesMap) : [];
      const currentFormatType = this.dropDownOptional.formatTypeFlag == 1 ? this.pickCurrentValue(this.formatTypes, this.dataFrom.formatType) : '';
      const currentFormatMap = this.dropDownOptional.formatTypeFlag == 1 ? couplesMap[currentFormatType] || {} : couplesMap;
      this.formatTypeIndex = this.formatTypes.indexOf(currentFormatType);

      if (this.dropDownOptional.lcTechnologyFlag == 1) {
        this.lcTechnologList = Object.keys(currentFormatMap);
        const currentLcTechnology = this.pickCurrentValue(this.lcTechnologList, this.dataFrom.lcTechnology);
        const currentLcTechnologyMap = currentFormatMap[currentLcTechnology] || {};
        const currentGoldWeigh = this.pickCurrentValue(this.mainStoneSort(Object.keys(currentLcTechnologyMap)), this.dataFrom.goldWeigh);

        this.lcTechnologyIndex = this.lcTechnologList.indexOf(currentLcTechnology);
        this.goldenWeighList = this.mainStoneSort(Object.keys(currentLcTechnologyMap));
        this.handSizeList = this.sortFun(
          currentGoldWeigh ? currentLcTechnologyMap[currentGoldWeigh] || [] : Object.values(currentLcTechnologyMap)[0] || [],
        );
      } else {
        const currentGoldWeigh = this.pickCurrentValue(this.mainStoneSort(Object.keys(currentFormatMap)), this.dataFrom.goldWeigh);
        this.lcTechnologList = [];
        this.lcTechnologyIndex = 0;
        this.goldenWeighList = this.mainStoneSort(Object.keys(currentFormatMap));
        this.handSizeList = this.sortFun(currentGoldWeigh ? currentFormatMap[currentGoldWeigh] || [] : Object.values(currentFormatMap)[0] || []);
      }
    },
    getSizeRange(value, type) {
      this.dataFrom[type] = value;

      if (type === 'gender') {
        this.dataFrom.formatType = '';
        this.dataFrom.lcTechnology = '';
        this.dataFrom.goldWeigh = '';
        this.dataFrom.ringSize = '';
        this.lcTechnologyIndex = 0;
      }
      if (type === 'formatType') {
        this.dataFrom.lcTechnology = '';
        this.dataFrom.goldWeigh = '';
        this.dataFrom.ringSize = '';
        this.lcTechnologyIndex = 0;
      }
      if (type === 'lcTechnology') {
        this.dataFrom.goldWeigh = '';
        this.dataFrom.ringSize = '';
      }
      if (type === 'goldWeigh') {
        this.dataFrom.ringSize = '';
      }

      if (['gender', 'settlementMethod', 'formatType', 'lcTechnology', 'goldWeigh'].includes(type)) {
        this.assembleOptionalData();
        this.defaultSelected();
        this.fetchPriceRange();
        return;
      }

      this.defaultSelected();
      this.fetchPriceRange();
    },
    sortFun(handSizeList) {
      return handSizeList?.sort(function (a, b) {
        return a - b;
      });
    },
    fetchPriceRange() {
      const obj = deepClone(this.dataFrom);
      // 有版型就只校验版型
      // if (this.formatTypes && this.formatTypes.length > 0) {
      //   if (!obj.formatType) return;
      // } else {
      //   // 没有版型就校验金重
      //   if (!obj.goldWeigh) return;
      // }
      if (obj.quantity == 0) obj.quantity = 1;
      getPriceRangeSpot(obj).then((res) => {
        if (obj.goldWeigh) {
          if (obj.goldWeigh?.includes('-')) {
            this.settlementWeight = new Decimal(obj.goldWeigh.split('-')[1]).mul(obj.quantity).toFixed(2);
          } else {
            this.settlementWeight = new Decimal(obj.goldWeigh).mul(obj.quantity).toFixed(2);
          }
        } else this.settlementWeight = 0;
        this.tradePrice = res.data.tradePrice;
        this.labelPrice = res.data.labelPrice;
        this.dataFrom.tradePrice = res.data.tradePrice;
        this.dataFrom.labelPrice = res.data.labelPrice;
        this.dataFrom.exclusivePrice = res.data.exclusivePrice;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom {
  .fx {
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }

  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .inchesTips {
    color: red;
    font-size: 12px;
    margin-left: 4px;
  }

  .material {
    width: 800px;

    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }

  .title {
    font-size: 18px;
    color: #000;
    display: inline-block;
    margin-bottom: 8px;

    .hidden {
      visibility: hidden;
    }
  }

  .value-font {
    font-size: 18px;
    color: #ec9368;
  }

  .mainStoneClssBoxFx {
    width: 675px;
    display: flex;
    align-items: center;
    position: relative;
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }

  ::v-deep .el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }

  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }

  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }

  .price-wrap {
    justify-content: flex-end;
  }

  .price-tips {
    color: red;
    margin-right: 10px;
  }
}
</style>
